import { isEmpty } from "../constants/Constants";

class CommonUtils {
  jumbleString(input) {
    const mid = input.length / 2;
    let parts = [input.substring(0, mid), input.substring(mid)];
    return (
      parts[0].split("").reverse().join("") +
      parts[1].split("").reverse().join("")
    );
  }
  encode(input) {
    input = this.jumbleString(input);
    let word = "";
    for (let index = 0; index < input.length; index++) {
      let c = input.charCodeAt(index) + 3;
      word = word + String.fromCharCode(c);
    }
    return word;
  }

  decode(input) {
    if (isEmpty(input)) return input;
    let org = "";
    for (let index = 0; index < input.length; index++) {
      const c = input.charCodeAt(index) - 3;
      org = org + String.fromCharCode(c);
    }
    org = this.jumbleString(org);
    return org;
  }
}

export default new CommonUtils();
